import { render, staticRenderFns } from "./AudioTracks.vue?vue&type=template&id=a407c67a&"
import script from "./AudioTracks.vue?vue&type=script&lang=ts&"
export * from "./AudioTracks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports